import { Icon, type INamedIconProps } from '@public/components/Icon/Icon';

export const EarlyEnrolleeIcon = ({ ...props }: INamedIconProps) => (
  <Icon
    height="12"
    iconName="EarlyEnrollee"
    viewBox="0 0 24 24"
    y="25%"
    {...props}
  />
);
